import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from 'react';
import { useLocation } from 'react-router-dom';

import '../../../index.css';
import {
  getPublishStyleEn,
  getPublishStyleKr,
} from '../../../utils/publishStyle';
import Title from '../../../components/Title';
import GuideModal from '../../../components/GuideModal';
import DeleteModal from '../ContentsList/DeleteModal';

import {
  getContentsList,
  getUserDetail,
  deletePublishedContents,
  getShopSkin,
  getMobileShopSkin,
  getMobileShopEnabled,
  getPublishedContentsList,
  getPublishedContentByNo,
} from '../../../modules/NetworkFunction';

import AuthContext from '../../../contexts/AuthContext';
import styled from 'styled-components';
import PreviewPage from '../Preview/PreviewPage';
import Modal from '../../Modal';
import usePaymentStatus from '../../../hooks/usePaymentStatus';
import checkedIcon from '../../../icons/ic-checked-yellow.png';
import pcIcon from '../../../icons/ic-pc-black.svg';
import mobileIcon from '../../../icons/ic-mobile-black.svg';
import pcIconChecked from '../../../icons/ic-pc-checked.svg';
import mobileIconChecked from '../../../icons/ic-mobile-checked.svg';
import icBack from '../../../icons/ic-arrow-back.svg';
import ShopModeContext from '../../../contexts/ShopModeContext';
import useCafe24Auth from '../../../hooks/useCafe24Auth';
function PostContent({ history }) {
  // 다른 페이지에서 props 받아오기위한 함수
  const location = useLocation();
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);
  const [shopVersion, setShopVersion] = useState(location.state.shopVersion);
  const [isPublishedContentsLoaded, setisPublishedContentsLoaded] =
    useState(false);

  const [selectedContentsNo, setSelectedContentsNo] = useState(
    location.state.contentsNo
  );
  const [isModify, setIsModify] = useState(location.state.isModify);
  const [contentStyle, setContentStyle] = useState('');
  const [publishedContentNo, setPublishedContentNo] = useState(
    location.state.publishedContentNo
  );

  const [publishedContent, setPublishedContent] = useState();

  const [user, setUser] = useState();
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [publishedContents, setPublishedContents] = useState([]);
  const [appliedDesign, setAppliedDesign] = useState([]);
  const [design, setDesign] = useState('');
  const [mobileDesign, setMobileDesign] = useState('');
  const [appliedMobileDesign, setAppliedMobileDesign] = useState([]);
  const [useMobileShop, setUseMobileShop] = useState(false);

  const { isPaid } = usePaymentStatus(token);
  const { accessToken } = useCafe24Auth();
  const shopNo = Number(localStorage.getItem('shopNo'));
  const mallId = localStorage.getItem('mallId');

  const [shopURL, setShopURL] = useState(location.state.shopURL);
  const isDisabled = !contentStyle;

  // 상세페이지 경로
  // const [detailPagePath, setDetailPagePath] = useState('/product/detail.html');
  const [detailPagePath, setDetailPagePath] = useState(location.state.detailPath);
  //가이드
  const [isHovered, setIsHovered] = useState(false);
  const reqParams = useMemo(() => {
    return {
      token: accessToken,
      mallId,
      shopNo,
    };
  }, [mallId, shopNo, accessToken]);

  useEffect(() => {
    getPublishedContentByNo(
     { publishedContentNo } ,
      (v) => {
        console.log(v)
        setPublishedContent(v)
      },
      () => {},
      (e) => {
        console.log('e:', e)
      },
      token
    )
  }, [])

  useEffect(() => {
    if (!isUserLoaded) {
      getUserDetail(
        null,
        (v) => {
          setUser(v.user);
        },
        setIsUserLoaded,
        (e) => {
          console.log('user error', e);
        },
        token
      );
      setContentStyle(getPublishStyleKr(location.state.style));
    }
  }, []);

  useEffect(() => {
    if (accessToken) {
      getMobileShopEnabled(
        reqParams,
        (v) => {
          setUseMobileShop(v);
        },
        (e) => {
          console.log('getMobileShopEnabled error');
        },
        token
      );

      getShopSkin(
        reqParams,
        (data) => {
          setDesign(data.skin_name);
          setAppliedDesign(data.appliedDesign);
        },
        () => {},
        (e) => {
          console.log(e);
        },
        token
      );

      getMobileShopSkin(
        reqParams,
        (data) => {
          setMobileDesign(data.skin_name);
          setAppliedMobileDesign(data.appliedDesign);
        },
        () => {},
        (e) => {
          console.log(e);
        },
        token
      );
    }
  }, [accessToken, token, reqParams]);

  useEffect(() => {
    if (!isPublishedContentsLoaded) {
      getPublishedContentsList(
        {
          userNo: window.sessionStorage.getItem('userNo'),
          shop: shopMode,
          flag: false
        },
        async (data) => {
          console.log(data)
          // 필터링하여 특정 쇼핑몰 모드에 맞는 데이터만 상태에 저장
          const filteredData = data.filter(
            (content) =>
              (shopMode === 'cafe24' && content.shop === 'cafe24') ||
              (shopMode === 'makeshop' && content.shop === 'makeshop')
          );

          // 상태 업데이트
          setPublishedContents(filteredData);
          console.log('filteredData : ', filteredData);
        },
        setisPublishedContentsLoaded,
        (error) => {
          console.error('Error loading published contents: ', error);
        },
        token
      );
    }
  }, [isPublishedContentsLoaded, shopMode, token]);

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
  };
  const openDeleteModal = useCallback((publishedContentNo) => {
    setDeleteModalOpen(true);
  });

  const handleNextBtn = () => {
    if (!contentStyle) {alert('콘텐츠 형태를 선택해주세요.'); return;}
    history.push({
      pathname: '/mypage/content-design-management',
      state: {
        user,
        isPaid,
        isModify,
        shopVersion,
        publishedContents,
        contentsNo: selectedContentsNo,
        publishedContentNo,
        style: getPublishStyleEn(contentStyle),
        detailPagePath:
          shopMode === 'cafe24'
            ? detailPagePath + '?product_no='
            : '/shop/shopdetail.html?branduid=',
        shopURL,
      },
    });
  };
  console.log('publishedContents', publishedContents);

  const handleDeleteContents = () => {
    // if (
    //   publishedContents.find(
    //     (v) => v.publishedContentNo === publishedContentNo
    //   ) !== undefined
    // ) {
    //   // 게시된 콘텐츠에 있으면 게시된 콘텐츠도 삭제를 해야함!
    //   //게시 콘텐츠 삭제
    //   let findContent = publishedContents.filter(
    //     (v) => v.publishedContentNo === publishedContentNo
    //   );
    //   findContent.forEach((item) => {
    //     deletePublishedContents(
    //       {
    //         publishedContentNo: location.state.publishedContentNo,
    //         //mobileYn: item.mobileYn,
    //       },
    //       () => {
    //         //setPublishedContents((prev) =>
    //         //  prev.filter((v) => v.publishContentNo !== item.publishContentNo)
    //         //);
    //       },
    //       (error) => {
    //         console.log(error);
    //       },
    //       token
    //     );
    //   });
    // }
    console.log('publishedContentNo', publishedContentNo);
    deletePublishedContents(
      {
        publishedContentNo: location.state.publishedContentNo,
        //mobileYn: item.mobileYn,
      },
      () => {
        //setPublishedContents((prev) =>
        //  prev.filter((v) => v.publishContentNo !== item.publishContentNo)
        //);
      },
      (error) => {
        console.log(error);
      },
      token
    );

    closeDeleteModal();
    window.history.back();
  };

  const handleChangeVersion = (version) => {
    if (
      !isPaid &&
      location.state.publishedMobileContentsCount >= 1 &&
      version === 'mobile'
    ) {
      alert('무료 요금제는 1개의 모바일 콘텐츠만 노출할 수 있습니다.');
      return;
    }

    if (
      !isPaid &&
      location.state.publishedPCContentsCount >= 1 &&
      version === 'pc'
    ) {
      alert('무료 요금제는 1개의 PC 콘텐츠만 노출할 수 있습니다.');
      return;
    }

    if (isModify && publishedContents) {
      // 게시된 콘텐츠 수정 시 콘텐츠가 pc 또는 모바일 둘 중 하나에 게시되어있는 경우
      alert('콘텐츠 게시 시에는 PC, 모바일 변경이 불가능합니다.');
      return;
    }

    setShopVersion(version);
  };

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      {/* 미리보기 페이지 모달 */}
      <Modal open={isPreviewModalOpen}>
        <PreviewPage
          closeModal={closePreviewModal}
          contentsNo={selectedContentsNo}
          contentStyle={contentStyle}
          onSelectContentStyle={setContentStyle}
          shopVersion={shopVersion}
          publishedContents={publishedContents}
          publishedContentNo={publishedContentNo}
          publishedContent={publishedContent}
        />
      </Modal>

        <img
          style={{ position: 'absolute', left: -30, top: 40, cursor: 'pointer' }}
          alt="뒤로 가기"
          src={icBack}
          onClick={() => window.history.back()}
        ></img>
        <Title title="콘텐츠 게시하기" />
      <p className="subtitle">콘텐츠</p>
      <ContentSelectBox>
        <img
          src={location.state.thumbnail}
          alt="thumbnail"
          style={{ width: '126px', height: '100%', borderRadius: '5px' }}
        ></img>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: 250,
            paddingLeft: 18,
          }}
        >
          <p
            style={{
              display: 'flex',
              fontSize: '20px',
              fontWeight: '700',
              color: '#000',
            }}
          >
            {location.state.title}
          </p>
          <p style={{ color: '#FFB600', fontSize: '12px', fontWeight: '500' }}>
            태그상품{' '}
            {location.state.productCount
              ? `${location.state.productCount}개`
              : '없음'}
          </p>
        </div>
      </ContentSelectBox>
      <p className="subtitle" style={{ marginBottom: '5px' }}>
        위치
      </p>

      <div
        style={{
          display: 'flex',
          padding: '10px 0',
          gap: '10px ',
          alignItems: 'center',
        }}
      >
        <div>
          <input
            type="radio"
            name="version"
            id="pc"
            value="pc"
            checked={shopVersion === 'pc'}
            onChange={() => {
              handleChangeVersion('pc');
            }}
            onClick={() => {
              setContentStyle('');
            }}
          />
          <div htmlFor="pc" className="shopVersionBtnWrapper">
            <img src={shopVersion === 'pc' ? pcIconChecked : pcIcon} alt="PC" />
            <label htmlFor="pc" style={{ cursor: 'pointer' }}>
              PC
            </label>
          </div>
        </div>
        <div>
          <input
            type="radio"
            name="version"
            id="mobile"
            value="mobile"
            checked={shopVersion === 'mobile'}
            onChange={() => {
              handleChangeVersion('mobile');
            }}
            onClick={() => {
              setContentStyle('');
            }}
          />
          <div className="shopVersionBtnWrapper" htmlFor="mobile">
            <img
              src={shopVersion === 'mobile' ? mobileIconChecked : mobileIcon}
              alt="Mobile"
            />
            <label htmlFor="mobile" style={{ cursor: 'pointer' }}>
              모바일
            </label>
          </div>
        </div>
      </div>

      {shopMode === 'cafe24' && (
        <>
          <p
            style={{
              color: '#848484',
              fontSize: '16px',
              fontWeight: '400',
              margin: '8px 0px 10px 0px',
            }}
          >
            현재 디자인
          </p>
          <div
            style={{
              color: '#848484',
              fontSize: '16px',
              fontWeight: '400',
              margin: '8px 0px 10px 0px',
            }}
          >
            {shopVersion === 'pc' ? design : mobileDesign}
          </div>
        </>
      )}

      <div className="inner-box">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 15,
            marginTop: 25,
            width: 665,
          }}
        >
          <p className="subtitle" style={{ marginBottom: 0 }}>
            콘텐츠 형태
          </p>
          <PreviewButton
            onClick={openPreviewModal}
            disabled={!selectedContentsNo}
          >
            미리보기
          </PreviewButton>
        </div>

        {
          // 콘텐츠 형태 선택
          shopVersion === 'pc' ? (
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 30,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '배너 가로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="banner_h"
                    value="banner_h"
                    onChange={(event) => {
                      setContentStyle('배너 가로');
                    }}
                    checked={contentStyle === '배너 가로'}
                  />

                  <label htmlFor="banner_h"></label>
                  <p style={{ color: '#b5b5b5' }}>배너 가로</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '배너 세로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="banner_v"
                    value="banner_v"
                    checked={contentStyle === '배너 세로'}
                    onChange={(event) => {
                      setContentStyle('배너 세로');
                    }}
                  />
                  <label htmlFor="banner_v"></label>
                  <p style={{ color: '#b5b5b5' }}>배너 세로</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '팝업 가로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="popup_h"
                    value="popup_h"
                    checked={contentStyle === '팝업 가로'}
                    onChange={(event) => {
                      setContentStyle('팝업 가로');
                    }}
                  />
                  <label htmlFor="popup_h"></label>
                  <p style={{ color: '#b5b5b5' }}>팝업 가로</p>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '팝업 세로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="popup_v"
                    value="popup_v"
                    checked={
                      shopVersion === 'pc' && contentStyle === '팝업 세로'
                    }
                    onChange={(event) => {
                      setContentStyle('팝업 세로');
                    }}
                  />
                  <label htmlFor="popup_v"></label>
                  <p style={{ color: '#b5b5b5' }}>팝업 세로</p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '서랍형' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents"
                    id="drawer"
                    value="drawer"
                    checked={shopVersion === 'pc' && contentStyle === '서랍형'}
                    onChange={() => {
                      setContentStyle('서랍형');
                    }}
                  />
                  <label htmlFor="drawer"></label>
                  <p style={{ color: '#b5b5b5' }}>서랍형</p>
                </div>
              </div>
              <div style={{ marginTop: 15 }}>
                <p style={{ color: '#848484', fontSize: 13 }}>
                  {' '}
                  *여러 형태로 동시에 노출을 원하는 경우, 하나의 형태에서 게시를
                  완료한 후 다시 콘텐츠 게시하기를 실행해주세요.
                </p>
              </div>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: 30,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '팝업 세로' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents_mobile"
                    id="popup_v_mobile"
                    value="popup_v_mobile"
                    checked={
                      shopVersion === 'mobile' && contentStyle === '팝업 세로'
                    }
                    onChange={(event) => {
                      setContentStyle('팝업 세로');
                    }}
                  />
                  <label htmlFor="popup_v_mobile"></label>
                  <p style={{ color: '#b5b5b5' }}>팝업 세로</p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  {contentStyle === '서랍형' ? (
                    <img
                      src={checkedIcon}
                      alt="checked"
                      style={{
                        position: 'absolute',
                        right: '-1px',
                        top: '-4px',
                        width: '21px',
                        height: '21px',
                      }}
                    />
                  ) : null}
                  <input
                    type="radio"
                    name="contents_mobile"
                    id="drawer_mobile"
                    value="drawer_mobile"
                    checked={
                      shopVersion === 'mobile' && contentStyle === '서랍형'
                    }
                    onChange={(event) => {
                      setContentStyle('서랍형');
                    }}
                  />
                  <label htmlFor="drawer_mobile"></label>
                  <p style={{ color: '#b5b5b5' }}>서랍형</p>
                </div>
              </div>
              <div style={{ marginTop: 15 }}>
                <p style={{ color: '#848484', fontSize: 13 }}>
                  *여러 형태로 동시에 노출을 원하는 경우, 하나의 형태에서 게시를
                  완료한 후 다시 콘텐츠 게시하기를 실행해주세요.
                </p>
              </div>
            </div>
          )
        }
      </div>
      {shopMode === 'cafe24' && (
        <div className="inner-box">
          <div
            style={{
              width: 560,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <p className="subtitle">콘텐츠 상세페이지 경로</p>
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                cursor: 'pointer',
                position: 'relative',
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img src="/icons/ic-question-mark.png" alt="help" />
              <p
                style={{
                  color: '#FF7A00',
                  cursor: 'pointer',
                  fontSize: 14,
                  marginLeft: 8,
                  textDecoration: isHovered ? 'underline' : 'none',
                  lineHeight: isHovered ? 'normal' : 'initial',
                }}
              >
                가이드
              </p>
              {isHovered && (
                <GuideModal
                  videoLink="https://www.youtube.com/watch?v=OZlIWSKTLnw"
                  pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/wizmon_product_detail_guide.pdf"
                />
              )}
            </div>
          </div>

          <input
            type="text"
            placeholder="붙여넣기"
            style={{
              width: 560,
              height: 45,
              padding: 10,
              background: 'rgba(231, 231, 231, 0.3)',
              color: '#848484',
            }}
            value={detailPagePath}
            onChange={(e) => {
              setDetailPagePath(e.target.value);
            }}
          />
          <p style={{ color: '#848484', fontSize: 12, marginTop: 6 }}>
            * 위즈몬 콘텐츠에서 상세페이지로 이동하는 경우, 가이드를 참고하여
            주소를 붙여 넣어주세요.
          </p>
        </div>
      )}
      <div
        style={{
          display: 'flex',
          gap: '14px',
          margin: '40px 0',
          justifyContent: 'flex-end',
        }}
      >
        <DeleteButton onClick={() => openDeleteModal(publishedContentNo)}>
          게시 삭제
        </DeleteButton>
        <SaveButton onClick={handleNextBtn}bgColor={isDisabled?"#b5b5b5" :"#ffb600"} fontColor={isDisabled?"#4d4d4d" :"#fff"} >다음</SaveButton>
      </div>
      <DeleteModal
        open={isDeleteModalOpen}
        close={closeDeleteModal}
        deleteContents={handleDeleteContents}
        contentsNo={publishedContentNo}
      ></DeleteModal>
    </div>
  );
}
export default PostContent;

const DeleteButton = styled.button`
  display: flex;
  width: 120px;
  height: 40px;
  border-radius: 20px;
  border: none;
  padding: 6px 6px;
  background-color: #ff3939;
  color: white;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  border-width: 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const SaveButton = styled.button`
  display: flex;
  width: 120px;
  height: 40px;
  border-radius: 20px;
  border: none;
  padding: 6px 6px;
  background-color: ${props => props.bgColor || '#ffb600'};
  color: ${props => props.fontColor || '#fff'};
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  border-width: 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const PreviewButton = styled.button`
  height: 27px;
  border-radius: 30px;
  border: 1px solid #ff7a00;
  padding: 0px 12px;
  background-color: white;
  color: #ff7a00;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
`;
const ContentSelectBox = styled.div`
  display: inline-flex;
  padding: 0;
  margin-bottom: 13px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  border: 0.5px solid rgba(0, 0, 0, 0.25);
  background: #f4f4f4;
  color: #848484;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
